import { useEffect, useState } from 'react';

export function ConnectivityNotice() {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div className="connectivity-notice" role="status">
      <span>离线模式</span>
      <p>已加载的公开案例仍可阅读；研究台和更新暂不可用。个人状态仍在本地。</p>
    </div>
  );
}
